import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {environment} from '../../../../../environments/environment.prod';
import {CommonService} from '../../../../services/common.service';
import {ConsentsFormService} from '../../../../services/consents-form.service';
import {MessageService} from '../../../../services/message.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
  selector: 'app-center',
  templateUrl: './center.component.html',
  styleUrls: ['./center.component.scss']
})
export class CenterComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() user;
  @Input() notifications;
  @Input() children;
  @Input() loadingNotifications;
  @Input() loadingCompletedConsents;
  @Input() loadingChildren;
  @Input() selectedChildren;
  @Input() historyScroll;
  messageVisible: boolean;
  pageLoaded = false;
  loadingMessage: boolean;
  @Output() deselectChild: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('history', {static: false}) history: ElementRef;
  message: any;
  publicForms: any = [];

  constructor(private consentsFormService: ConsentsFormService,
              private commonService: CommonService,
              public toastMessagesService: ToastMessagesService,
              private messageService: MessageService) {
    this.messageVisible = false;
    this.loadingMessage = false;
  }

  ngOnChanges(changes: any) {
    if (changes.historyScroll && this.pageLoaded) {
      this.navigateToHistory(history);
    }

    if (changes.loadingChildren) {
    }

  }

  ngAfterViewInit() {
    this.pageLoaded = true;
  }

  async loadLastMessage() {
    try {
      this.loadingMessage = true;
      this.message = await this.messageService.getLastMessage();

      if (this.message) {
        this.messageVisible = true;
      } else {
        this.messageVisible = false;
      }
      // this.messageVisible = !this.message === null;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingMessage = false;
    }
  }

  navigateToHistory($element) {
    this.history.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  }

  async ngOnInit() {
    await this.loadLastMessage();
    if (environment.productSchoolId !== 1) {
      await this.loadPublicForms();
    }
    console.log(this.selectedChildren)
  }

  async loadPublicForms() {
    try {
      if (environment.productSchoolId === 2) {
        const publicFormsRequest = await this.commonService.getList(`forms/publish/fetch`);
        this.publicForms = publicFormsRequest.object;
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(`Υπήρξε κάποιο πρόβλημα προσπαθώντας να ενημερώσουμε τη λίστα των δημόσιων δηλώσεων`);
    }
  }

  async showConsent(child, notification: any) {
    await this.consentsFormService.showCustomForm(notification, this.user, child);
    // if (notification.mode === 'customForm') {
    //     await this.consentsFormService.showCustomForm(notification, this.user, child);
    // } else {
    //     await this.consentsFormService.showConsent(notification, this.user, child);
    // }
  }

  userDisplayName(entry: any) {
    return `${entry.firstName} ${entry.lastName}`;
  }

  childrenDisplayName(child: any) {
    return `${child.firstName} ${child.lastName}`;
  }

  checkMessageVisibility($event: any) {
    this.messageVisible = $event;
  }

  closeChild(child: any) {
    this.deselectChild.emit(child.id);
  }

  async displayPublicForm(form: any) {
    console.log(form);
    await this.consentsFormService.showCustomPublicForm(form, true);
  }

  currentYearNotifications(notifications: any) {
    const currentYear = new Date().getFullYear();
    const currentSchoolYear = new Date(`${currentYear}-09-01`);
    const currentYearsNotifications = notifications.filter(notification => new Date(notification.notificationDate) >= currentSchoolYear);
    // console.log(`Current year - ${currentYearsNotifications.length}`);
    return currentYearsNotifications;
  }

  pastYearNotifications(notifications: any) {
    const currentYear = new Date().getFullYear();
    const currentSchoolYear = new Date(`${currentYear}-09-01`);
    const pastYearsNotifications = notifications.filter(notification => new Date(notification.notificationDate) < currentSchoolYear);
    // console.log(`Past year - ${pastYearsNotifications.length}`);

    return pastYearsNotifications;
  }
}
